<div class="btr-billing">
    <ng-container *ngIf="group">
        <div class="btr-billing__grid" [formGroup]="group">
            <div class="btr-billing__billed">
                <ds-input
                    class="btr-billing__billed-input"
                    [id]="'btr_billed_hours'"
                    formControlName="totalBilledHours"
                    label="Billed hours"
                    type="number"
                    min="0"
                    placeholder="0.00"
                >
                    <span suffix>hrs</span>
                    <mat-hint>{{ billedHoursInfo }}</mat-hint>
                    <mat-error>{{ hoursError }}</mat-error>
                </ds-input>
                <ds-text class="btr-billing__totals" size="sm" weight="medium" theme="secondary" [text]="totalsText"></ds-text>
            </div>

            <ds-input [id]="'btr_cost'" class="btr-billing__cost" formControlName="cost" type="number" label="Cost" placeholder="0">
                <span prefix>$</span>
            </ds-input>

            <ds-input [id]="'btr_profit'" class="btr-billing__profit" formControlName="profit" type="number" label="Profit" placeholder="0">
                <span prefix>$</span>
            </ds-input>

            <ds-input
                [id]="'btr_invoice'"
                class="btr-billing__invoice"
                formControlName="invoiceID"
                label="Invoice #"
                placeholder="For example INV-26-0356"
            ></ds-input>

            <ds-select
                [id]="'btr_month_year'"
                class="btr-billing__month"
                formControlName="monthYear"
                label="Month and year *"
                placeholder="Select month and year"
                [options]="monthYearOptions"
                [compareWith]="compareById"
            >
                <mat-error>{{ monthYearError }}</mat-error>
            </ds-select>

            <dl class="btr-billing__computed">
                <div class="btr-billing__computed-item">
                    <dt><ds-text size="sm" weight="medium" theme="secondary" text="Rate"></ds-text></dt>
                    <dd><ds-text size="md" weight="semibold" theme="primary" [text]="rate"></ds-text></dd>
                </div>
                <div class="btr-billing__computed-item">
                    <dt><ds-text size="sm" weight="medium" theme="secondary" text="Flight margin"></ds-text></dt>
                    <dd><ds-text size="md" weight="semibold" theme="primary" [text]="flightMargin"></ds-text></dd>
                </div>
            </dl>

            <div class="btr-billing__status" role="group" aria-labelledby="btr_billing_status">
                <span id="btr_billing_status" class="ds-form-control__label">Accounting status</span>
                <div class="btr-billing__checks">
                    <ng-container *ngIf="!isAddMode">
                        <ds-checkbox label="Contracted" [formControl]="contractedControl"></ds-checkbox>
                    </ng-container>
                    <ds-checkbox formControlName="ar" label="A/R (receivable)"></ds-checkbox>
                    <ds-checkbox formControlName="ap" label="A/P (payable)"></ds-checkbox>
                </div>
            </div>

            <ds-textarea
                [id]="'btr_note'"
                class="btr-billing__note"
                formControlName="note"
                label="Note"
                placeholder="Add a note for accounting"
                [maxlength]="noteMaxLength"
                [minRows]="2"
            >
                <mat-hint>{{ noteCounter }}</mat-hint>
                <mat-error>Enter {{ noteMaxLength }} characters or fewer.</mat-error>
            </ds-textarea>
        </div>
    </ng-container>
</div>
